function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcePoolAws(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 172",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    style: {
      fill: "none",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-91.856 931.2V190.87h740.33V931.2z",
    style: {
      mixBlendMode: "normal",
      fill: "none",
      stroke: "none",
      strokeWidth: 4.30423975
    },
    transform: "matrix(.16456 0 0 .16457 40.201 -6.328)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal",
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.472 77.146c0 2.139.23 3.87.63 5.142a30.898 30.898 0 0 0 1.832 4.16c.286.462.4.924.4 1.33 0 .576-.343 1.153-1.085 1.734l-3.605 2.426c-.516.347-1.028.52-1.487.52-.573 0-1.143-.291-1.716-.81a17.858 17.858 0 0 1-2.06-2.717 44.707 44.707 0 0 1-1.774-3.408c-4.462 5.314-10.07 7.973-16.82 7.973-4.806 0-8.64-1.386-11.442-4.16-2.802-2.773-4.232-6.471-4.232-11.094 0-4.91 1.716-8.897 5.206-11.9s8.124-4.508 14.015-4.508c1.946 0 3.949.172 6.063.462 2.114.29 4.29.753 6.579 1.272v-4.217c0-4.39-.914-7.454-2.688-9.245-1.83-1.792-4.92-2.66-9.323-2.66-2.003 0-4.06.23-6.178.753-2.118.52-4.175 1.154-6.178 1.964-.914.405-1.602.634-2.003.753-.401.114-.688.172-.914.172-.802 0-1.2-.577-1.2-1.792v-2.83c0-.925.115-1.617.401-2.022.287-.405.803-.81 1.602-1.215 2.003-1.039 4.404-1.906 7.21-2.601 2.802-.753 5.776-1.097 8.922-1.097 6.809 0 11.786 1.56 14.99 4.68 3.145 3.121 4.747 7.858 4.747 14.212v18.719h.108zm-23.227 8.779c1.888 0 3.834-.348 5.89-1.04 2.061-.691 3.892-1.963 5.436-3.697.914-1.097 1.602-2.312 1.946-3.698.344-1.387.574-3.064.574-5.028v-2.426a46.837 46.837 0 0 0-5.264-.982 43.045 43.045 0 0 0-5.379-.347c-3.834 0-6.636.752-8.525 2.311-1.888 1.559-2.802 3.755-2.802 6.644 0 2.716.688 4.737 2.118 6.123 1.372 1.448 3.375 2.14 6.006 2.14zm45.938 6.242c-1.029 0-1.717-.172-2.175-.577-.459-.348-.857-1.154-1.2-2.254L54.362 44.677c-.344-1.154-.516-1.906-.516-2.311 0-.925.458-1.444 1.372-1.444h5.608c1.086 0 1.831.172 2.233.577.458.347.799 1.153 1.143 2.254L73.813 82l8.923-38.248c.286-1.154.63-1.907 1.085-2.254.459-.348 1.258-.577 2.29-.577h4.576c1.086 0 1.831.172 2.29.577.458.347.856 1.153 1.086 2.254l9.037 38.71 9.897-38.71c.344-1.154.745-1.907 1.143-2.254.459-.348 1.2-.577 2.232-.577h5.322c.913 0 1.43.462 1.43 1.444 0 .29-.058.577-.115.924-.058.348-.172.81-.402 1.444l-13.785 44.66c-.344 1.153-.745 1.906-1.2 2.253-.455.348-1.2.577-2.175.577h-4.92c-1.086 0-1.831-.172-2.29-.577-.459-.405-.856-1.153-1.086-2.31l-8.865-37.268-8.808 37.21c-.286 1.154-.63 1.906-1.085 2.311-.46.405-1.258.577-2.29.577zm73.508 1.559c-2.974 0-5.948-.348-8.807-1.04-2.86-.691-5.092-1.444-6.58-2.31-.913-.52-1.544-1.097-1.773-1.617a4.097 4.097 0 0 1-.344-1.616v-2.945c0-1.215.459-1.792 1.315-1.792.344 0 .688.057 1.028.172.344.115.857.348 1.43.577a30.849 30.849 0 0 0 6.292 2.02 34.03 34.03 0 0 0 6.809.692c3.605 0 6.407-.634 8.353-1.906 1.945-1.272 2.974-3.121 2.974-5.49 0-1.616-.516-2.945-1.545-4.045-1.028-1.097-2.974-2.078-5.776-3.003l-8.296-2.601c-4.174-1.33-7.263-3.294-9.151-5.895-1.889-2.54-2.86-5.371-2.86-8.378 0-2.426.516-4.565 1.545-6.414 1.028-1.85 2.404-3.465 4.117-4.737 1.716-1.33 3.662-2.311 5.948-3.003 2.29-.688 4.69-.978 7.21-.978 1.258 0 2.573.057 3.834.229 1.315.172 2.516.405 3.72.634 1.143.29 2.232.577 3.26.925 1.029.347 1.831.691 2.405 1.039.802.462 1.372.924 1.716 1.444.344.462.516 1.097.516 1.906v2.717c0 1.214-.458 1.849-1.315 1.849-.459 0-1.2-.23-2.175-.692-3.26-1.501-6.923-2.254-10.983-2.254-3.26 0-5.834.52-7.607 1.616-1.774 1.097-2.688 2.774-2.688 5.142 0 1.616.574 3.003 1.717 4.103 1.143 1.097 3.26 2.197 6.292 3.179l8.123 2.601c4.118 1.33 7.095 3.178 8.866 5.547 1.77 2.369 2.63 5.085 2.63 8.088 0 2.483-.516 4.737-1.487 6.7-1.029 1.964-2.405 3.698-4.175 5.085-1.774 1.444-3.891 2.483-6.35 3.236-2.583.81-5.27 1.215-8.188 1.215z",
    style: {
      fill: "#252f3e"
    },
    transform: "matrix(.70832 0 0 .70833 25.085 25.083)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.502 121.805c-18.82 14.04-46.164 21.492-69.678 21.492-32.948 0-62.64-12.305-85.064-32.758-1.774-1.616-.172-3.813 1.945-2.54 24.256 14.21 54.173 22.821 85.122 22.821 20.88 0 43.821-4.39 64.927-13.405 3.15-1.444 5.837 2.078 2.748 4.39zm7.837-9.012c-2.404-3.122-15.903-1.502-22.023-.753-1.831.23-2.118-1.387-.459-2.601 10.754-7.626 28.43-5.433 30.49-2.889 2.061 2.602-.573 20.454-10.638 29.004-1.545 1.33-3.032.634-2.347-1.097 2.29-5.719 7.381-18.604 4.977-21.664z",
    style: {
      fill: "#f90"
    },
    transform: "matrix(.70832 0 0 .70833 25.085 25.083)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m34.507 10.779-23.291 10.75v129l23.291 10.75m102.983-150.5 23.293 10.75v129l-23.292 10.75",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#7a7a7a",
      strokeWidth: 10.74999046,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "fill markers stroke"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcePoolAws);
export default __webpack_public_path__ + "static/media/resourcePoolAws.c68c1b7ea536460c9d5094998fe9d3c3.svg";
export { ForwardRef as ReactComponent };